import {
  COMPANY,
  SELLPOINTS,
  WORKWITHUS,
  CONTACT_US,
  PAYMENT_METHODS,
} from '@shared/helpers/routes';

import { sxHeader } from './styles';

export const navigationButtons = (pageConfiguration, history) => [
  {
    show: pageConfiguration.site_functions.showCompany,
    label: 'Empresa',
    onClick: () => history.push(COMPANY),
  },
  {
    show: pageConfiguration.site_functions.showFranchise,
    label: 'Franquicias',
    href: 'http://franquicias.viajestdh.com.ar',
    target: '_blank',
  },
  {
    show: pageConfiguration.site_functions.showPointsOfSale,
    label: 'Puntos de venta',
    onClick: () => history.push(SELLPOINTS),
  },
  {
    show: pageConfiguration.site_functions.showWorkWithUs,
    label: 'Trabajá con Nosotros',
    onClick: () => history.push(WORKWITHUS),
  },
  {
    show: pageConfiguration.site_functions.showPaymentMethods,
    label: 'Formas de Pago',
    onClick: () => history.push(PAYMENT_METHODS),
  },
  {
    show: pageConfiguration.site_functions.showContact,
    label: 'Contacto',
    onClick: () => history.push(CONTACT_US),
  },
  {
    show: pageConfiguration.site_functions.showFifteen,
    type: 'logo',
    logoSrc: pageConfiguration.site_logos.fifteenNavLogo,
    alt: pageConfiguration.site_logos.alt || '15 años',
    href: 'http://quince.viajestdh.com.ar',
    target: '_blank',
    logoSx: sxHeader.logoQuince,
  },
];
